// 부트스트랩 설정.
const $ = require('jquery');
window.$ = window.jQuery = $;
window.$.datepicker = require('jquery-ui/ui/widgets/datepicker');
window.$.selectize = require('selectize');
window.Popper = require('popper.js');
window.feather = require("feather-icons");
window.axios = require('axios');
window.Vue = require('vue').default;
window.ToastUiEditor = require('@toast-ui/editor');


import "jquery-mask-plugin/dist/jquery.mask.min";

import Swiper from 'swiper/bundle';
import moment from "moment"
// 이미지맵 리사이징.
import ImageMap from "image-map";

import AddressSearch from './components/AddressSearch.vue';
import "./push/push";

window.push = require("./push/push").default;

window.Vue.component('address-search', AddressSearch);

window.Swiper = Swiper;
window.moment = moment;

require('bootstrap');
// require('@babel/polyfill');

window.mwHelper = require("./helper").default;

// 아이콘 설정.
document.addEventListener("DOMContentLoaded", () => {
    feather.replace();
    $('[data-toggle="tooltip"]').tooltip();
    ImageMap('img[usemap]');

    $("body").on("click", ".popup-open", function (e) {
        e.preventDefault();

        const me = $(this);
        let url = me.data("url");
        let name = me.data("name");
        let width = parseInt(me.data("width"));
        let height = parseInt(me.data("height"));
        let top = parseInt(me.data("top"));
        let left = parseInt(me.data("left"));

        mwHelper.openPopup(url, width, height, top, left, name);
    }).on("mouseenter", "table.table-row-bg tbody td", function () {
        const $tr = $(this).parent();
        $(".table-row-bg tr[data-key=" + $tr.data("key") + "] td").addClass("td-mouseover-bg");
    }).on("mouseleave", "table.table-row-bg tbody td", function () {
        const $tr = $(this).parent();
        $(".table-row-bg tr[data-key=" + $tr.data("key") + "] td").removeClass("td-mouseover-bg");
    });

    // 휴대전화번호 형식 처리.
    const mask_hp = function (val) {
        const masks = ['000-0000-0000', '000-000-00009'];
        return (val.replace(/[^0-9]/g, "").length === 10) ? masks[1] : masks[0];
    };

    $('.mask-hp').each(function () {
        const me = $(this);

        me.mask(mask_hp(me.val()), {
            onKeyPress: function (cep, e, field, options) {
                field.mask(mask_hp(cep), options);
            }
        })
    });

    // 전화번호 형식 처리.
    const mask_tel = function (val) {
        const masks = [
            '00-000-0000999',
            '000-000-000099',
            '000-0000-00009',
            '0000-0000-0000',
        ];

        let mask = masks[0];

        switch (val.replace(/[^0-9]/g, "").length) {
            case 10 :
                mask = masks[1];
                break
            case 11 :
                mask = masks[2];
                break
            case 12 :
                mask = masks[3];
                break
        }

        return mask;
    };

    $('.mask-tel').each(function () {
        const me = $(this);

        me.mask(mask_tel(me.val()), {
            onKeyPress: function (cep, e, field, options) {
                field.mask(mask_tel(cep), options);
            }
        });
    });

    function isAndroid(){ return /Android/i.test(navigator.userAgent || ""); }
    function isIOS(){ return /iPhone|iPad|iPod/i.test(navigator.userAgent || ""); }

    $(".deeplink").on("click", function (e) {
        e.preventDefault();

        const $el = $(this);
        const web      = $el.attr("href") || "/";
        const iosApp   = $el.data("ios");
        const iosStore = $el.data("iosStore");
        const andUrl   = $el.data("android");
        const andPlay  = $el.data("androidPlay");
        const timeout  = parseInt($el.data("timeout"), 10) > 0 ? parseInt($el.data("timeout"), 10) : 1500;
        if (isAndroid()) {
            if (andUrl) {
                window.location.href = andUrl;
                setTimeout(() => {
                    if (document.visibilityState === "visible") {
                        window.location.href = andPlay || web;
                    }
                }, timeout);
            } else if (andPlay) {
                window.location.href = andPlay;
            } else {
                window.location.href = web;
            }
            return;
        }

        if (isIOS()) {
            if (iosApp) {
                const t0 = Date.now();
                window.location.href = iosApp;
                setTimeout(() => {
                    if (Date.now() - t0 < timeout) {
                        window.location.href = iosStore || web;
                    }
                }, timeout);
            } else if (iosStore) {
                window.location.href = iosStore;
            } else {
                window.location.href = web;
            }
            return;
        }

        window.location.href = web;
    });
});

// 크로스 사이트 처리를 위한 코드.
// 다른 도메인의 사이트에서 데이터를 전달 받음.
window.addEventListener('message', function (e) {
    if (e.data.callback) {
        // ...처리 로직 (부모창 함수 호출)
        window[e.data.callback](e.data.arguments);
    }
});


/**
 * 지도 검색.
 * @param callback
 */
window.search_address = function (callback) {
    const callbackName = "cb" + Math.round((Math.random() * 1000000000));
    const url = webRoot + "areas/search?callback=" + callbackName + "&delivery_charge=on";
    const width = 550;
    const left = (screen.availWidth - width) / 2;

    window[callbackName] = function (data) {
        let deliveryCharge = data.deliveryCharge;

        if (typeof deliveryCharge == "string") {
            deliveryCharge = parseInt(deliveryCharge);
        }

        callback({
            address: data.address,
            address_detail: data.detail,
            zipcode: data.zipcode || '00000',
            deliveryCharge: deliveryCharge,
        });
    };

    const popup = window.open(
        url,
        callbackName,
        "scrollbars=1,resizable=1,width=" + width + ",height=550,top=100,left=" + left
    );

    return !(!popup || popup.closed || typeof popup.closed === "undefined");
};

// 클립보드로 텍스트 복사.
window.copy_to_clipboard = function (val) {
    if (!document.execCommand) {
        alert("클립보드로 복사가 지원되지 않는 브라우저입니다.");
        return false;
    }

    const t = document.createElement("textarea");
    document.body.appendChild(t);
    t.value = val;
    t.select();
    document.execCommand('copy');
    document.body.removeChild(t);
    return true;
}

window.loadScript = function (FILE_URL, async = true, type = "text/javascript") {
    return new Promise((resolve, reject) => {
        try {
            const scriptEle = document.createElement("script");
            scriptEle.type = type;
            scriptEle.async = async;
            scriptEle.src = FILE_URL;

            scriptEle.addEventListener("load", (ev) => {
                resolve({status: true});
            });

            scriptEle.addEventListener("error", (ev) => {
                reject({
                    status: false,
                    message: `Failed to load the script ${FILE_URL}`
                });
            });

            document.body.appendChild(scriptEle);
        } catch (error) {
            reject(error);
        }
    });
};

